import React from 'react';
import PropTypes from 'prop-types';

import Slider from 'react-slick';
import { Icon } from 'semantic-ui-react';
import ReactPlayer from 'react-player';

import { useBreakpoints } from '$app/common/utils/mediaQueries';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const PrevSlide = ({ className, onClick }) => {
  const { isSmDown } = useBreakpoints();

  return (
    <div
      className={className}
      css={{
        '&.slick-prev': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 205,
          height: isSmDown ? 200 : 500,
          background: 'rgba(125, 73, 152, 0.8)',
          borderTopRightRadius: 10,
          borderBottomRightRadius: 10,
          zIndex: 99,
          left: -215,
          cursor: 'initial',
          top: isSmDown ? 100 : 250,

          '&::before': {
            content: '""',
          },

          '&:hover': {
            background: 'rgba(125, 73, 152, 0.8)',
          },
        },
      }}
    >
      <Icon
        name="sh-left-arrow"
        onClick={onClick}
        css={{
          '&&&.icon': {
            color: 'black',
            marginLeft: isSmDown ? '85%' : '20%',
            fontSize: isSmDown ? '1.5rem' : '4rem',
            cursor: 'pointer',
          },
        }}
      />
    </div>
  );
};

PrevSlide.propTypes = {
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

const NextSlide = ({ className, onClick }) => {
  const { isSmDown } = useBreakpoints();

  return (
    <div
      className={className}
      css={{
        '&.slick-next': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 205,
          height: isSmDown ? 200 : 500,
          background: 'rgba(163, 58, 115, 0.8)',
          borderTopLeftRadius: 10,
          borderBottomLeftRadius: 10,
          zIndex: 99,
          right: -215,
          cursor: 'initial',
          top: isSmDown ? 100 : 250,

          '&::before': {
            content: '""',
          },

          '&:hover': {
            background: 'rgba(163, 58, 115, 0.8)',
          },
        },
      }}
    >
      <Icon
        name="sh-right-arrow"
        onClick={onClick}
        css={{
          '&&&.icon': {
            color: 'black',
            marginRight: isSmDown ? '80%' : '20%',
            fontSize: isSmDown ? '1.5rem' : '4rem',
            cursor: 'pointer',
          },
        }}
      />
    </div>
  );
};

NextSlide.propTypes = {
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

const CompanyPhotoGallery = ({ companyPhotoList, companyVideoList }) => {
  const { isSmDown } = useBreakpoints();

  const settings = {
    infinite: true,
    speed: 500,
    prevArrow: <PrevSlide />,
    nextArrow: <NextSlide />,
    className: 'slider-container',
  };

  return (
    <div
      css={{
        width: '80vw',
        margin: 'auto',
      }}
    >
      <Slider {...settings}>
        {companyPhotoList?.map(slide => (
          <div>
            <div
              css={{
                paddingLeft: 10,
                paddingRight: 10,
              }}
            >
              <img
                alt={slide}
                src={slide}
                css={{
                  objectFit: 'cover',
                  width: '100%',
                  height: isSmDown ? 200 : 500,
                  borderRadius: 10,
                }}
              />
            </div>
          </div>
        ))}
        {companyVideoList?.map(slide => (
          <div>
            <div
              css={{
                paddingLeft: 10,
                paddingRight: 10,
              }}
            >
              <ReactPlayer
                width="100%"
                controls
                height={isSmDown ? 200 : 500}
                url={slide}
                css={{
                  '& > div > iframe': {
                    borderRadius: 10,
                  },
                }}
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

CompanyPhotoGallery.propTypes = {
  companyPhotoList: PropTypes.arrayOf(PropTypes.array).isRequired,
  companyVideoList: PropTypes.arrayOf(PropTypes.array).isRequired,
};

export default CompanyPhotoGallery;
